export class DeleteDashboard {
  public static readonly type = '[Project/Dashboard/List] DeleteDashboard';
  constructor(public readonly id: string) {}
}
